import { render, staticRenderFns } from "./BudgetComment.vue?vue&type=template&id=1b7a3306&scoped=true"
import script from "./BudgetComment.vue?vue&type=script&lang=js"
export * from "./BudgetComment.vue?vue&type=script&lang=js"
import style0 from "./BudgetComment.vue?vue&type=style&index=0&id=1b7a3306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a3306",
  null
  
)

export default component.exports